import { DateTime } from "luxon";

export function getScheduledUeForModule(
  events: Array<{ start: DateTime; end: DateTime; courseModuleName?: null | string }>,
  moduleName: string,
) {
  return events.reduce((ueSum, event) => {
    if (event.courseModuleName === moduleName) {
      ueSum += event.end.diff(event.start, "minutes").minutes / 45;
    }
    return ueSum;
  }, 0);
}
